import "./index.css";

import React from "react";
import { Controller } from "react-hook-form";

import { cn } from "../../../utils/utils";

const CustomPaymentInput = (props) => {
  const {
    control,
    name,
    max,
    type,
    onchange,
    errors,
    placeholder,
    className,
    disabled,
    tabIndex,
    required = false,
  } = props;

  return (
    <div className={cn(" flex flex-col gap-1 ", className)}>
      <div className=" textInputWrapper">
        <Controller
          control={control}
          name={name}
          render={({ field }) => {
            return (
              <input
                //autoFocus={false}
                tabIndex={tabIndex ? tabIndex : "0"}
                value={field.value}
                className="textInput "
                disabled={disabled}
                onChange={(e) => field.onChange(e.target.value)}
                placeholder={`${placeholder}${required ? "*" : ""}`}
                type={type}
                onKeyUp={onchange}
                maxLength={max}
                onWheel={(e) => e.target.blur()}
              />
            );
          }}
        />
      </div>
      {errors && <span className="text-red-500 text-[12px] tracking-tight">{errors?.message}</span>}
    </div>
  );
};

export default CustomPaymentInput;
// import { cn } from "../../../utils/utils";
// import React from "react";
// import "./index.css"

// const CustomPaymentInput = (props) => {
//   const { register, name, max, type, onchange, errors, placeholder, className, disabled, tabIndex, required = false } = props;

//   return (
// <div className={cn(" flex flex-col gap-1 ", className)}>
//       <div className=" textInputWrapper">

//         <input
//           tabIndex={tabIndex ? tabIndex : "0"}
//           className="textInput "
//           {...register(name, {
//             required: required && {
//               value: true,
//               message: ` ${placeholder} اجباری است ` // Custom required message here
//             }
//           })}
//           name={name}
//           placeholder={`${placeholder}${required?"*":""}`}
//           disabled={disabled}
//           type={type}
//           onKeyUp={onchange}
//           maxLength={max}

//           onWheel={(e) => e.target.blur()}
//         />

//       </div>
//       {errors && <span className="text-red-500 text-[12px] tracking-tight">{errors?.message}</span>}
// </div>
//   );
// };

// export default CustomPaymentInput;
